import { Injectable, inject } from '@angular/core';

import { Types } from '../../types.domain';

import { UseAuthorizationCodeServiceInterface } from '../interfaces/services/use-authorization-code.service.interface';
import { UseAuthorizationCodeInput } from '../dtos/use-authorization-code.input';
import { UseAuthorizationCodeOutput } from '../dtos/use-authorization-code.output';

@Injectable()
export class UseAuthorizationCodeService
  implements UseAuthorizationCodeServiceInterface
{
  private readonly _authRepository = inject(Types.AuthRepository);

  async handle(
    input: UseAuthorizationCodeInput
  ): Promise<UseAuthorizationCodeOutput> {
    return await this._authRepository.useAuthorizationCode(input);
  }
} 